import React from 'react';
import Nav from "../../components/nav";
import MyCart from "../../components/cart/myCart";

const Cart = () => {
    return (
        <div>
            <Nav/>
            <MyCart/>
        </div>
    );
};

export default Cart;